import { forwardRef } from 'react';

/**
 * Semantic main landmark — use in place of a content wrapper div; keep the same className.
 */
export const PageMain = forwardRef(function PageMain({ className = '', children, ...rest }, ref) {
  return (
    <main id="main-content" ref={ref} className={className} {...rest}>
      {children}
    </main>
  );
});
